module.exports = __webpack_public_path__ + "media/offers/paper-3-78264134.png";